<template>
  <section class="register-select-currency">
    <i-select :value="value" :clearable="false" @input="input">
      <i-option
        v-for="(item, key) in currencies"
        :key="key"
        :value="item.id"
        :label="item.title.toUpperCase()"
      />
    </i-select>
    <div class="register-select-currency__message">
      <p>
        {{ $t('core.register.choose_currency') }}
      </p>
      <span style="color: red">{{ $t('core.register.change_not_possible') }}</span>
    </div>
  </section>
</template>

<script>
  import { Currency } from '@shared/helpers/currency';

  export default {
    props: {
      value: {
        type: [String, Number],
        default: Currency.USD_ID
      }
    },
    computed: {
      currencies() {
        return Currency.ObjectList;
      }
    },
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
<style lang="scss">
  .register-select-currency {
    position: relative;
    .ivu-select-single .ivu-select-selection,
    .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
    .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
      height: 38px;
    }
    .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
    .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
      display: flex;
      align-items: center;
      color: black;
    }
    &__message {
      position: absolute;
      right: -100%;
      left: calc(100% + 15px);
      top: -15px;

      width: 305px;
      /* height: auto; */
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
      background-color: #ffffff;
      border: solid 1px #c5c5c5;
      padding: 14px;
      font-size: 13px;
      color: #394858;
      border-radius: 5px;
      z-index: 99;
      &:after {
        right: 100%;
        top: 23%;
        content: ' ';
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border: 10px solid rgba(136, 183, 213, 0);
        border-right-color: #fff;
        margin-top: -10px;
      }
    }
  }
</style>
